import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useLazyForgotPasswordQuery,
  useLazyRegisterQuery,
} from "../../../Store/Builder/techsbook.api";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import useTimer from "../../Hooks/timer";
import showToast from "../../Hooks/toast";

const useResendEmailCode = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [resendCodeForgot] = useLazyForgotPasswordQuery();
  const [resendCodeSignup] = useLazyRegisterQuery();
  const { timer, isRunning, startTimer } = useTimer(60);

  const send = (data) => {
    dispatch(setLoader(true));
    const resendFun =
      location?.state?.method === "signup"
        ? resendCodeSignup
        : resendCodeForgot;
    resendFun(data)
      .unwrap()
      .then((res) => {
        startTimer();
        dispatch(setLoader(false));
        showToast(res?.label + " " + location?.state.email, "success");
        navigate("/verify-email", {
          state: {
            email: location?.state.email,
            verify_token: res?.verify_token,
          },
        });
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message, "error");
      });
  };

  return {
    send,
    timer,
    isRunning,
  };
};

export default useResendEmailCode;
